import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { entityRoutes } from './entity.routing';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FuseMasonryModule } from '@fuse/components/masonry';
import { NoteEventsComponent } from './notes/note-events/note-events.component';
import { AddNoteComponent } from './notes/add-note/add-note.component';
import {DocumentEventsComponent,DialogDataExampleDialog} from './documents/document-events/document-events.component';
import {AddDocumentComponent} from './documents/add-document/add-document.component';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import {ContactsEventsComponent} from './contacts/contacts-events/contacts-events.component';
import {AddContactComponent} from  './contacts/add-contact/add-contact.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AddressEventsComponent} from './address/address-events/address-events.component';
import {AddAddressComponent} from './address/add-address/add-address.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { AddTimingComponent } from './facility-timings/add-timing/add-timing.component';
import { AddHolidaysComponent } from './holidays/add-holidays/add-holidays.component';
import {AdditionalInfoEntityComponent} from './additional-info-entity/additional-info-entity.component';
import { LoadingModule } from 'app/shared/loading/loading/loading.module';
import { FuseAlertModule } from '@fuse/components/alert';
import {NgxMatTimepickerModule} from 'ngx-mat-timepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TimingsComponent } from './facility-timings/timings/timings.component';
import { MatTableModule } from '@angular/material/table';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { AddDocumentComponent1 } from './documents/add-document-feed/add-document.component';

@NgModule({
    declarations: [
        NoteEventsComponent,
        AddNoteComponent,
        AddDocumentComponent,
        AddDocumentComponent1,
        DocumentEventsComponent,
        DialogDataExampleDialog,
        ContactsEventsComponent,
        AddContactComponent,
        AddressEventsComponent,
        AddAddressComponent,
        AddTimingComponent,
        ReviewsComponent,AddHolidaysComponent,AdditionalInfoEntityComponent, TimingsComponent
    ],
    imports     : [
        RouterModule.forChild(entityRoutes),
        SharedModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatSidenavModule,
        FuseMasonryModule,
        MatSelectModule,MatExpansionModule,
        FormsModule,ReactiveFormsModule,LoadingModule,FuseAlertModule,NgxMatTimepickerModule,MatTooltipModule,MatDatepickerModule,MatTableModule,MatSlideToggleModule

    ],
    exports     : [ReviewsComponent,AdditionalInfoEntityComponent,TimingsComponent,AddTimingComponent
    ]
})
export class EntityModule
{
}
